module.exports = __webpack_public_path__ + "img/new_legal_documents_icon.a88e1b4.png";